<app-header></app-header>
<app-option-bar></app-option-bar>

<div class="content-center">

    <div class="parent-content content-2 row">

        <div class="content-center content-1">
            <p class="title col-6">
                Hola, tus canales en Energy Center
            </p>
        </div>

        <div class="filter-container">
            <input type="text" placeholder="Filtrar por nombre" (input)="filterItems($event)">
        </div>

        <div class="table-container">
            <table hlmTable class="table">
                <thead hlmTableHeader>
                    <tr hlmTableRow>
                        <th hlmTableHead></th>
                        <th hlmTableHead>Estado</th>
                        <th hlmTableHead>Logo</th>
                        <th hlmTableHead>Nombre</th>
                        <th hlmTableHead>Marca</th>
                        <th hlmTableHead>Subcanal</th>
                        <th hlmTableHead>Gestión Canal</th>
                    </tr>
                </thead>
                <tbody hlmTableBody>
                    @for (item of filteredItems; track item.id) {
                        <tr hlmTableRow>
                            <td hlmTableCell>
                                <input type="checkbox" [(ngModel)]="item.selected">
                            </td>
                            <td hlmTableCell>
                                <span class="circle" [ngStyle]="{'color': getCircleColor(item.active)}">&#x25CF;</span>
                                {{ item.active == 1 ? 'Activo' : 'Inactivo' }}
                            </td>
                            <td hlmTableCell class="image-cell">
                                <img class="logo" [src]="item.logo" alt="ICONO NO DISPONIBLE">
                            </td>
                            <td hlmTableCell>{{ item.name }}</td>
                            <td hlmTableCell>{{ item.label }}</td>
                            <td hlmTableCell>{{ item.channel_id }}</td>
                            <td hlmTableCell>
                                <button class="buttonCheck" (click)="verDatos(item)">Ver</button>
                                <button class="buttonCheck" (click)="editarDatos(item)">Activar</button>
                                <button class="buttonCheck" (click)="eliminarDatos(item)">Desactivar</button>
                            </td>
                        </tr>
                    } @empty {
                        <tr hlmTableRow>
                            <td hlmTableCell colspan="7">No hay canales registrados.</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>
